import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            关于喑网91的常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            快速找到您想了解的关于喑网91的各类问题解答
          </p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4>
                  <a
                    href={`#faq-${idx + 1}`}
                    onClick={(e) => e.preventDefault()}
                    className="text-sm font-medium text-foreground-900 no-underline"
                  >
                    {item.question}
                  </a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center ml-4 shrink-0">
                  <i className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line text-foreground-500`}></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-6 pb-5" id={`faq-${idx + 1}`}>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}